// extracted by mini-css-extract-plugin
export default {"activityToggle":"Actions_activityToggle__QrFuU","toggleButton":"Actions_toggleButton__tiLdn"};